import { FeedTypeEnum } from '@/types'
import type { BadgeVariants } from '@/ui'

export const FEED_TITLES: Record<FeedTypeEnum, string> = {
  [FeedTypeEnum.CALL]: 'Call',
  [FeedTypeEnum.INQUIRY]: 'Incoming inquiry',
  [FeedTypeEnum.MESSAGE]: 'Message',
  [FeedTypeEnum.CALL_NOTE]: 'Call Note',
  [FeedTypeEnum.NOTE]: 'Note',
  [FeedTypeEnum.FILE]: 'File uploaded',
  [FeedTypeEnum.EVENT]: 'Appointment',
  [FeedTypeEnum.CLIENT_CHANGES]: 'Patient info',
  [FeedTypeEnum.PAYMENT]: 'Payment',
  [FeedTypeEnum.PATIENT_JOURNEY]: 'Patient Journey',
}

export const FEED_COLORS: Record<FeedTypeEnum, BadgeVariants['variant']> = {
  [FeedTypeEnum.CALL]: 'yellow',
  [FeedTypeEnum.INQUIRY]: 'green',
  [FeedTypeEnum.MESSAGE]: 'blue',
  [FeedTypeEnum.CALL_NOTE]: 'purple',
  [FeedTypeEnum.NOTE]: 'indigo',
  [FeedTypeEnum.FILE]: 'pink',
  [FeedTypeEnum.EVENT]: 'red',
  [FeedTypeEnum.CLIENT_CHANGES]: 'lime',
  [FeedTypeEnum.PAYMENT]: 'orange',
  [FeedTypeEnum.PATIENT_JOURNEY]: 'teal',
}

export const FEED_TYPE_COLOR_CLASSES: Record<FeedTypeEnum, string> = {
  [FeedTypeEnum.CALL]: 'bg-yellow-100 dark:bg-yellow-900/50',
  [FeedTypeEnum.INQUIRY]: 'bg-green-100 dark:bg-green-900/50',
  [FeedTypeEnum.MESSAGE]: 'bg-blue-100 dark:bg-blue-900/50',
  [FeedTypeEnum.CALL_NOTE]: 'bg-purple-100 dark:bg-purple-900/50',
  [FeedTypeEnum.NOTE]: 'bg-indigo-100 dark:bg-indigo-900/50',
  [FeedTypeEnum.FILE]: 'bg-pink-100 dark:bg-pink-900/50',
  [FeedTypeEnum.EVENT]: 'bg-red-100 dark:bg-red-900/50',
  [FeedTypeEnum.CLIENT_CHANGES]: 'bg-lime-100 dark:bg-lime-900/50',
  [FeedTypeEnum.PAYMENT]: 'bg-orange-100 dark:bg-orange-900/50',
  [FeedTypeEnum.PATIENT_JOURNEY]: 'bg-teal-100 dark:bg-teal-900/50',
}
